import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { ReactComponent as UploadFileIcon } from 'presentation/assets/icons/upload-file-icon.svg'
import { ReactComponent as PendencyIcon } from 'presentation/assets/icons/pendency-time-line-icon.svg'
import { ReactComponent as PointerRight } from 'presentation/assets/icons/pointer-right.svg'
import { ReactComponent as SolicitationCancelIcon } from 'presentation/assets/icons/solicitation-cancel.svg'
import { SurgicalTimeLineActions } from 'common/enum/surgical-order-time-line-actions'
import { ProfileLocated } from 'common/enum/profile'
import { TimeLineTypes } from '../../types'
import * as S from './styles'

export const TimeLineTab = ({
  timeLineItems,
  loadSurgicalPendency,
  setSelectedPendencyHistory,
  setHistoryVisible,
  setCancelSolicitationVisible
}: TimeLineTypes) => {
  const [selectedUpdateItem, setSelectedUpdateItem] = useState('') as any
  const [hasIndexRequestedCancellation, setHasIndexRequestedCancellation] =
    useState<number>(-1)

  function selectItem(index: number, surgical_pendency_id: number) {
    setSelectedUpdateItem(index)
    if (surgical_pendency_id) {
      loadSurgicalPendency(surgical_pendency_id)
      setHistoryVisible(true)
    } else {
      setSelectedPendencyHistory(undefined)
      setHistoryVisible(false)
    }
  }

  function requestedCancellation() {
    if (
      timeLineItems.some(
        (item) =>
          item.action_type ===
          SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER
      )
    ) {
      setCancelSolicitationVisible(true)
    } else {
      setCancelSolicitationVisible(false)
    }
  }

  const hasRequestedCancellation = timeLineItems?.some(
    (item) =>
      item?.action_type ===
      SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER
  )

  function getIndexOfCancellationRequest() {
    let indexOfObjectFound = -1

    for (let i = 0; i < timeLineItems?.length; i++) {
      if (
        timeLineItems[i]?.action_type ===
        SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER
      ) {
        indexOfObjectFound = i
        break
      }
    }

    if (indexOfObjectFound !== -1) {
      setHasIndexRequestedCancellation(indexOfObjectFound)
    }
    return indexOfObjectFound
  }

  useEffect(() => {
    const index = getIndexOfCancellationRequest()

    if (index !== -1 && hasRequestedCancellation) {
      selectItem(
        hasIndexRequestedCancellation,
        timeLineItems[0]?.surgical_pendency_id
      )
      requestedCancellation()
    }
  }, [timeLineItems, hasIndexRequestedCancellation])

  return (
    <S.TimeLineContainer>
      <S.TimeLineTitle>Atualizações sobre o pedido</S.TimeLineTitle>
      {timeLineItems
        ?.map((item, index) => {
          return (
            <div
              key={index}
              onClick={() => {
                selectItem(index, item.surgical_pendency_id)
                requestedCancellation()
              }}
            >
              <S.TimeLineItem selected={selectedUpdateItem === index}>
                <div>
                  {item.action_type ===
                  SurgicalTimeLineActions.REQUESTED_CANCELLATION_SURGICAL_ORDER ? (
                    <>
                      <SolicitationCancelIcon width={40} />
                    </>
                  ) : item.document_category ? (
                    <>
                      <UploadFileIcon width={40} />
                    </>
                  ) : (
                    <PendencyIcon width={40} />
                  )}
                </div>

                <S.InfoWrapper>
                  <p>{item.action}</p>
                  <strong>
                    {
                      ProfileLocated[
                        item.persona as keyof typeof ProfileLocated
                      ]
                    }
                    <span>
                      {' '}
                      •{' '}
                      {moment
                        .utc(item.created_at)
                        .locale('pt-br')
                        .format('DD [de] MMMM [de] YYYY')}{' '}
                      às{' '}
                      {moment.utc(item.created_at).locale('pt-br').format('LT')}
                    </span>
                  </strong>
                </S.InfoWrapper>
                <S.PointerContainer>
                  <PointerRight />
                </S.PointerContainer>
              </S.TimeLineItem>
            </div>
          )
        })
        ?.reverse()}
    </S.TimeLineContainer>
  )
}
